import { render, staticRenderFns } from "./ActivityTimeLineItemAssignees.vue?vue&type=template&id=54f3bcfa&"
import script from "./ActivityTimeLineItemAssignees.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemAssignees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports